import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="w-full bg-[#0f172a] py-24 px-4 text-center" data-id="element-271">
      <div className="max-w-3xl mx-auto" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1e293b] p-10 md:p-16 rounded-3xl border border-[#334155] shadow-2xl relative overflow-hidden flex flex-col items-center" data-id="element-273">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#334155]/20 to-transparent pointer-events-none" data-id="element-274" />

          <span className="text-[#94a3b8] text-2xl line-through relative z-10 mb-2" data-id="element-275">
            $19
          </span>

          <h2 className="font-serif text-6xl md:text-7xl font-bold text-white mb-2 relative z-10" data-id="element-276">
            $6.36
          </h2>

          <p className="text-[#94a3b8] text-xl mb-4 relative z-10" data-id="element-277">
            (pago único)
          </p>

          <div className="flex flex-col items-center gap-2 mb-10 relative z-10" data-id="element-278">
            <div className="bg-[#5b8a7a]/20 border border-[#5b8a7a]/40 rounded-full px-4 py-1.5" data-id="element-279">
              <span className="text-[#7fb3a0] font-medium text-sm" data-id="element-280">
                Ahorras $12.64 — 66% de descuento
              </span>
            </div>
            <div className="bg-[#e8856c]/15 border border-[#e8856c]/30 rounded-full px-4 py-1.5" data-id="element-281">
              <span className="text-[#e8856c] font-medium text-sm" data-id="element-282">
                🔥 Precio de Lanzamiento — Por Tiempo Limitado
              </span>
            </div>
          </div>

          <p className="text-[#cbd5e1] text-lg mb-10 max-w-md relative z-10" data-id="element-283">
            Esto está diseñado para ser una compra fácil en el momento exacto
            donde tu cerebro dice:{' '}
            <span className="text-[#e8856c] italic" data-id="element-284">"Necesito algo ya."</span>
          </p>

          <motion.a href="https://www.betterbysteps.com/cart/44204964905053:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="self-center inline-flex bg-[#e8856c] text-white px-10 py-4 rounded-xl text-base font-bold shadow-[0_0_30px_rgba(232,133,108,0.4)] hover:shadow-[0_0_40px_rgba(232,133,108,0.6)] transition-all items-center justify-center gap-2 relative z-10 no-underline" data-id="element-285">
            Quiero Mi Guion de 2AM
            <ArrowRight className="w-5 h-5" data-id="element-286" />
          </motion.a>

          <div className="mt-6 flex items-center justify-center gap-2 text-[#64748b] text-sm relative z-10" data-id="element-287">
            <Download className="w-4 h-4" data-id="element-288" />
            <span data-id="element-289">Descarga inmediata · PDF + Tarjetas imprimibles</span>
          </div>
        </motion.div>
      </div>
    </section>;
}